import { ITask } from "../GorevYoneticisiTypes";
import { AbstractTaskHandler } from "./AbstractTaskHandler";
import PttBarkodSorgula from "@/plugins/uyap-plugin/uyap/PttBarkodSorgula";
import { TaskDurum } from "../../../enum/TaskDurum";
import { TaskResult } from "../../../enum/TaskResult";
import Vue from "vue";

export class BarkodSorgulaTaskResponse {
    kartNo: string = ""
    dosyaEsasNo: string = ""
    barkodNo: string = ""
    message: string = ""
    items: any[] = []
}

export class BarkodSorgulaTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        try {
            const barkodNo = task.data?.barkod_no;
            const tebligatId = task.data?.tebligat_id;
            const kartNo = task.data?.takip_id;
            const dosyaEsasNo = task.data?.dosya_esas_no;

            if (!barkodNo) {
                task.status = TaskDurum.BITTI_HATALI;
                task.description = "Barkod numarası bulunamadı.";
                return task;
            }
            task.response  = new BarkodSorgulaTaskResponse();
            task.response.kartNo = kartNo;
            task.response.barkodNo = barkodNo;
            task.response.dosyaEsasNo = dosyaEsasNo;

            const ptt = new PttBarkodSorgula();
            const result = await ptt.run([ barkodNo ]);
            // PTT'den gelen yanıtı kontrol edelim
            if (result.status === "error" || result.items.length == 0) {
                task.status = TaskDurum.BITTI_HATALI;
                task.response.message = result.message;
                task.description = result.message || "Barkod sorgulamada PTT servisinden hata alındı.";
                task.result = TaskResult.fail;
                return task;
            }

            // Sorgu başarılı oldu
            task.status = TaskDurum.BITTI_BASARILI;
            task.description = "Barkod sorgulama işlemi başarıyla tamamlandı.";
            task.result = TaskResult.success;
            
            if(result.message.includes("TESLİM EDİLDİ")){
                task.description = "Tebligat başarıyla teslim edilmiştir.";
            }else if(result.message.includes("BİLA")){
                task.description = "Tebligat bila edilmiştir.";
            }
            
            // Gönderim tarihi olarak ilk kaydı kullanalım
            const ilkIslem = result.items[0];
                
            try {
                // Tebligat kaydını güncelleme isteği gönderelim
                await Vue.prototype.$http.put('/api/v1/tebligat', {
                    id: tebligatId,
                    ...(result.updateData || {})
                });

            } catch (updateError) {
                console.error('Tebligat güncelleme hatası:', updateError);
                // Tebligat güncellenemedi ama sorgu başarılı olduğu için görevi başarılı sayalım
            }
            
            return task;
        } catch (e) {
            task.status = TaskDurum.BITTI_HATALI;
            task.result = TaskResult.fail;
            
            // Hata bilgisini düzgün şekilde kaydedelim
            if (e instanceof Error) {
                task.description = e.message;
            } else {
                task.description = "Barkod sorgulama sırasında beklenmeyen bir hata oluştu.";
            }
            
            return task;
        }
    }
}